module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_35",
      "title": "35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1957")])])]), _vm._v(" "), _c('p', {
    staticClass: "LHF"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SP"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" None")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("None")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("After 1955 and 1956 lulled me into a false sense of complacency—with me thinking that I could see in the Hugo Awards of those years the beginnings of the award I know today—1957 took me by surprise. The Worldcon that year was in London, Loncon I, the first overseas Worldcon. And British fans clearly decided to do something different with the Hugos. Something really different. Something indeed that makes no sense to me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There were three categories for the Hugos of 1957, and none of them was fiction. They were Best US Magazine, Best British Magazine, and best Fan Magazine. I suppose this might reflect the prevailing view that magazines were where it was at, as well as British fans being unable to get hold of US books easily—which was a problem until 1994. But it must also reflect a belief that it isn’t the stories that matter; it’s where you read them. However, they did have nominees, so that’s a good sign.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_36",
      "title": "36"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("THER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ATEGORIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("MERICAN")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Astounding")]), _vm._v(", edited by John W. Campbell Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Anybody surprised? But this streak was about to be broken.")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF,")]), _vm._v(" edited by Anthony Boucher")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Galaxy,")]), _vm._v(" edited by H. L. Gold")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Infinity,")]), _vm._v(" edited by Larry T. Shaw")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF")]), _vm._v(" is the only magazine on the list still going under its original name. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Galaxy")]), _vm._v(" was also a great magazine. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Infinity")]), _vm._v(" is not such a well-known magazine, at least now, but it published Clarke’s “The Star” the year before, so they were doing something right.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RITISH")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("New Worlds,")]), _vm._v(" edited by John Carnell")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominee:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nebula,")]), _vm._v(" edited by Peter Hamilton")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Wait, Britain had two science fiction magazines? Why didn’t I know this? Perhaps because it was before I was born.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AN")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Science-Fiction Times,")]), _vm._v(" edited by James V. Taurasi, Ray Van Houten, and Frank R. Prieto Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Inside,")]), _vm._v(" edited by Ron Smith")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_37",
      "title": "37"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hyphen,")]), _vm._v(" edited by Walt Willis and Chuck Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hyphen")]), _vm._v(" was robbed, I tell you, those old "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hyphen")]), _vm._v("s were golden.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Other categories they might have had? Well, they could have thought about novels, you know. Short fiction? But it’s interesting that they were all reading the same fanzines but not the same novels and magazines.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The International Fantasy Award went to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Lord of the Rings,")]), _vm._v(" presumably considered as one thing. The International Fantasy Award then expired, presumably considering that with the publication of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Lord of the Rings,")]), _vm._v(" fantasy was now over.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Plausible nominees: Arthur C. Clarke’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The City and the Stars,")]), _vm._v(" John Christopher’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Death of Grass")]), _vm._v(" (a cozy catastrophe), Frank Herbert’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Dragon in the Sea")]), _vm._v(" (claustrophobic futuristic undersea adventure), Philip Dick’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Man Who Japed")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The World Jones Made")]), _vm._v(" (I don’t like Dick, but lots of people do), Isaac Asimov’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Naked Sun")]), _vm._v(" (sequel to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Caves of Steel,")]), _vm._v(" one of Asimov’s best), A. E. van Vogt’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Players of Null-A")]), _vm._v(" (aka "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Pawns of Null-A")]), _vm._v("), Frederik Pohl’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Slave Ship,")]), _vm._v(" Alfred Bester’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Stars My Destination")]), _vm._v(" (aka "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tiger! Tiger!")]), _vm._v("), C. S. Lewis’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Till We Have Faces")]), _vm._v(" (a weird fantasy based on Cupid and Psyche).")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Or in YA: C. S. Lewis’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Last Battle,")]), _vm._v(" Asimov’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lucky Starr")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Big Sun of Mercury,")]), _vm._v(" Eleanor Cameron’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Stowaway to the Mushroom Planet,")]), _vm._v(" and Heinlein’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Time for the Stars.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I think out of all that, they might have been able to find something Hugo-worthy, don’t you? There were some great books published in 1956, even if it wasn’t quite so vintage a year as 1955. I think I’d have been torn between "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The City and the Stars")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Stars My Destination,")]), _vm._v(" but "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Naked Sun")]), _vm._v(" is also terrific, and I’m very fond of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Time for the Stars.")]), _vm._v(" What an odd year. What a relief it will be to get to 1958!")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OMMENTS ON")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1957")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("6. M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARCUS")]), _vm._v(" R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OWLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nebula")]), _vm._v(" was a Scottish magazine, edited by Peter Hamilton (not the author, who was born a year after it folded), in print from 1952 to 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_38",
      "title": "38"
    }
  }, [_vm._v("7. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICH")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTON")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The story I have heard—though, having been two years old at the time, I can’t vouch for it—is that the reason no fiction categories were included was to protect the (British-administered) International Fantasy Award from competition. As you note, it was protected so well that it died immediately after!")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I would certainly consider "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Stars My Destination")]), _vm._v(" the proper Hugo winner for 1957, myself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("How about short fiction? Possible nominees, from a quick scan of the ISFB short fiction list for 1957: “Bodyguard,” by “Christopher Grimm” (really Evelyn E. Smith); “Brightside Crossing,” by Alan E. Nourse; “Horrer Howce,” by Margaret St. Clair; “Margin of Profit,” by Poul Anderson; “Fair,” by “Keith Woodcott” (really John Brunner); “Plus X,” by Eric Frank Russell; “Stranger Station,” by Damon Knight; “The Country of the Kind,” by Damon Knight; “The Anything Box,” by Zenna Henderson; “The Dead Past,” by Isaac Asimov; “The Man Who Came Early,” by Poul Anderson; “The Man Who Ate the World,” by Frederik Pohl; “The Skills of Xanadu,” by Theodore Sturgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I have a feeling I’ve forgotten some. My five-story nomination list would be “The Country of the Kind,” “The Man Who Came Early,” “The Dead Past,” “Horrer Howce,” and maybe “Stranger Station” or “The Skills of Xanadu.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’d pick “The Dead Past” or “The Man Who Came Early” as the winners (maybe the first is “Best Novella” and the second “Best Short Story”), though I think “The Country of the Kind” is right up there too.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("10. B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OB")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Weird year, all right. In the short fiction category, I would also include the prescient “And Now the News…” by Sturgeon, and as novella the last collaboration of Kuttner and Moore—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rite of Passage")]), _vm._v("; and one of Asimov’s most liked stories was also published—“The Last Answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("12. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICH")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTON")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Bob—good catch of “And Now the News…”—definitely one of the best stories of 1956, and now I can’t decide whether I’d vote for it or the Asimov or the Anderson.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_39",
      "title": "39"
    }
  }, [_vm._v("14. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OB")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ANSEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Interestingly, they used the same rockets for the Hugo in 1957 that had always been used for the IFAs. So while the bases were different, the actual trophies were identical.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("16. D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AVID")]), _vm._v(" G. H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARTWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Someone did in fact give International Fantasy Awards in 1956, to Frank Herbert’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Dragon in the Sea,")]), _vm._v(" tied with William Golding’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lord of the Flies.")]), _vm._v(" I have a copy of the Gollancz first UK edition of the Herbert, with a band around it announcing the awards. And Frank showed me a picture of him accepting the award. Best I can figure, the American meeting on the IFA did not take place, but the UK one did, and the Brits unilaterally gave the awards. And the US fans refused to record them (to this day).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d6b789","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 87
// module chunks = 0